import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-share-android",
  templateUrl: "./med-icon-share-android.component.html",
})
export class MedIconShareAndroidComponent extends SvgMixinComponent {}
